"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _getFallbackImage = _interopRequireDefault(require("../getFallbackImage"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function getBreakpointFallback(breakpoint, props) {
  var fallback = (0, _getFallbackImage["default"])(props);
  var imageData = props[breakpoint];

  if (!(imageData !== null && imageData !== void 0 && imageData.src)) {
    return {
      src: fallback.src,
      width: (fallback === null || fallback === void 0 ? void 0 : fallback.width) || '100%',
      height: (fallback === null || fallback === void 0 ? void 0 : fallback.height) || 'auto'
    };
  }

  return {
    src: imageData === null || imageData === void 0 ? void 0 : imageData.src,
    width: (imageData === null || imageData === void 0 ? void 0 : imageData.width) || '100%',
    height: (imageData === null || imageData === void 0 ? void 0 : imageData.height) || 'auto'
  };
}

var _default = getBreakpointFallback;
exports["default"] = _default;
//# sourceMappingURL=getBreakpointFallback.js.map